import {AgentsPlugin} from '@github-ui/agent-sessions/agents-plugin'
import {TasksPlugin} from '@github-ui/agent-sessions/tasks-plugin'
import type {ImmersivePlugin} from '@github-ui/copilot-chat/plugin'
import type {HandleUserSubmit} from '@github-ui/one-copilot-composer/user-submit'
import type {RefObject} from 'react'
import {useMemo} from 'react'

export interface UseImmersivePluginsPayload {
  sparkEnabled?: boolean
  agentsEnabled?: boolean
  dashboardModulesEnabled?: boolean
}

export interface UseImmersivePluginsOptions {
  payload: UseImmersivePluginsPayload
  handleUserSubmitRef?: RefObject<HandleUserSubmit>
  isEmbedded?: boolean
  managedDefaultModelEnabled?: boolean
}

export function useImmersivePlugins({
  payload,
  handleUserSubmitRef,
  isEmbedded,
  managedDefaultModelEnabled = false,
}: UseImmersivePluginsOptions): ImmersivePlugin[] {
  const plugins = useMemo(() => {
    const pluginsList: ImmersivePlugin[] = []

    const shouldCreateTaskFromList = payload.dashboardModulesEnabled ?? true

    if (!isEmbedded) {
      pluginsList.push(
        new AgentsPlugin(
          shouldCreateTaskFromList,
          handleUserSubmitRef,
          payload.agentsEnabled ?? false,
          managedDefaultModelEnabled,
        ),
      )
    }

    // Tasks plugin is now always enabled
    pluginsList.push(new TasksPlugin())

    return pluginsList
  }, [
    payload.agentsEnabled,
    payload.dashboardModulesEnabled,
    isEmbedded,
    handleUserSubmitRef,
    managedDefaultModelEnabled,
  ])

  return plugins
}
